import axios from "axios";
import { useEffect, useState } from "react";
import { Application } from "../common.interface";
import { toast } from "react-toastify";


// type updateDataType = {
//     approverId:string,
//     approverName:string,
//     status:string
// }

export default function useApplication(){
    const [loading,setLoading]=useState<boolean>(false);
    const [applicationsData,setApplicationsData] = useState<Application[]>([]);

    const fetchApplications = async() => {
 
        try {
            setLoading(true);
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/application/`)

               if(res.status===200){
                const data = res.data.data;
                const newData = data.map((item:Application)=>({...item,'createdAt':item.createdAt.replace('T'," ").split('.')[0]}))

                setApplicationsData(newData)
                // setLoading(false)
              }
            //   setLoading(false)
      
        } catch (error) {
            // setLoading(false)
            
      toast.error(`${(error as any).message}`, {
        position: toast.POSITION.TOP_LEFT,
        toastId: 'application-fetch-error'

      });  
            // console.log('error',error);
        }finally{
            setLoading(false);
        }


    }
    const updateApplication = (_data:Application)=>{   
        setLoading(true);
        const data =  applicationsData.map((applicationData)=>applicationData._id===_data._id?{..._data}:applicationData);
        setApplicationsData(data); 
        setLoading(false);
        }

    useEffect(()=>{
        fetchApplications()
    },[]);

    return {
        loading,
        fetchApplications,
        updateApplication,
        applicationsData
    }
}